
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-kiem-tra-benh-duong-tieu-hoa",
      function () {
        return require("private-next-pages/goi-kiem-tra-benh-duong-tieu-hoa/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-kiem-tra-benh-duong-tieu-hoa"])
      });
    }
  